import axios from 'axios'
import app from '@/main.js'
const $api2 = axios.create({
  baseURL: process.env.VUE_APP_API_URL_V2,
  timeout: 600000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
  },
})
$api2.interceptors.request.use((config) => {
  const token = localStorage.getItem('srAccessToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
$api2.interceptors.response.use(
  function (response) {
      // 응답 데이터를 가공
      // ...
      return response;
  },
  function (error) {
     
       
      if(error.response){
        let response = error.response
        if(error.response.status == 401){
          localStorage.removeItem('SR_Token')
          app.loadingHide();  
          app.$router.push('/login')
        }else{
          if(response.data instanceof Blob){
            const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
            const responseData = isJsonBlob(response?.data) ? (response?.data)?.text() : response?.data || {};
            const responseJson = (typeof responseData === "string") ? JSON.parse(responseData) : responseData;
            responseJson.then((result) =>{
             
              let r = JSON.parse(result)
              app.alert({msg:r.message});  
            })
          }else{
            let msg = error.response.data.message
            switch(msg) {
              case "Request failed with status code 409" :
                app.alert({msg:'이미 등록된 주소입니다.'})
                break;
              default:
                app.alert({msg:error.response.data.message});
                break;
                
            }
           
          }
          
        };
      }else{
        console.log(error)
        app.loadingHide();
        //app.alert({msg:error.response.data.message});
      }
      
      
      return Promise.reject(error);
  }
);
 
 
export default $api2

